export default __webpack_public_path__ + "static/media/photo1.a8fd2550.JPG";